import script from "./productSystem.vue?vue&type=script&setup=true&lang=js"
export * from "./productSystem.vue?vue&type=script&setup=true&lang=js"

import "./productSystem.vue?vue&type=style&index=0&id=cddb1236&scoped=true&lang=less"

import exportComponent from "/workspace/office-website/company-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cddb1236"]])

export default __exports__